<tp-page-scaffold [pageAvailability]="availability$ | async">
  <article>
    <h1 class="tp-title">
      Welcome to TypeDB, {{ userFirstName$ | async }}
    </h1>
    <div class="home-page-body">
      <div class="tp-bento-box tp-deploy-cluster">
        <div class="tp-deploy-cluster-button-area">
          <h2>Deploy a cluster</h2>
          @if (clusterExists$ | async) {
            <p>Launch a cluster on TypeDB Cloud.</p>
          } @else {
            <p>Launch your first cluster on TypeDB Cloud.</p>
          }
          <div class="flex-spacer"></div>
          <a [routerLink]="clustersDeployPath(team)">
            <tp-button buttonId="deployCluster" buttonStyle="primary-outline green stroke">
              Deploy
            </tp-button>
          </a>
        </div>

        <div class="flex-spacer"></div>
        <div class="logo">
          <img src="/assets/logo/cluster-deploy-swirl.svg" alt=""/>
        </div>
      </div>
      <div class="tp-bento-container row">
        <a class="tp-bento-box hoverable tp-icon-card flex-1" target="_blank" href="https://typedb.com/docs/learn-typedb/">
          <i class="fa-thin fa-seedling"></i>
          <div class="tp-icon-card-content">
            <h3>Learn TypeDB<i class="fa-light fa-arrow-up-right"></i></h3>
            <p>Follow a 5-minute quickstart or a deeper dive to learn how to use TypeDB.</p>
          </div>
        </a>
        <a class="tp-bento-box hoverable tp-icon-card flex-1" href="https://typedb.com/docs/use-cases/" target="_blank">
          <i class="fa-thin fa-microchip"></i>
          <div class="tp-icon-card-content">
            <h3>Use cases<i class="fa-light fa-arrow-up-right"></i></h3>
            <p>Browse TypeDB examples and use cases.</p>
          </div>
        </a>
      </div>

      <div class="tp-bento-container row tp-bento-box tp-additional-resources-container">
        <h3>Additional Resources</h3>
        <p>Check out the community or learn more about TypeDB</p>
        <div class="tp-additional-resources">
          <a href="https://typedb.com" target="_blank">
            <svg width="20" height="20" viewBox="0 0 22 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" id="typedb">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22 13.1675C22 7.18494 17.0751 2.33508 11 2.33508C4.92487 2.33508 0 7.18494 0 13.1675C0 19.1501 4.92487 24 11 24C17.0751 24 22 19.1501 22 13.1675ZM6.57074 7.91736L15.29 7.91734C18.2677 7.91734 20.6816 10.2945 20.6816 13.2268C20.6816 16.1569 18.2695 18.5322 15.2941 18.5322L6.63986 18.5258C3.66107 18.5236 1.24319 16.153 1.22788 13.2196C1.21267 10.3062 3.59858 7.93239 6.55697 7.91741L6.57074 7.91736Z" fill="currentColor"/>
              <path d="M9.95701 13.2586C9.95701 14.5064 8.89424 15.518 7.58325 15.518C6.27226 15.518 5.20949 14.5064 5.20949 13.2586C5.20949 12.0107 6.27226 10.9991 7.58325 10.9991C8.89424 10.9991 9.95701 12.0107 9.95701 13.2586Z" fill="currentColor"/>
              <path d="M17.1772 13.2586C17.1772 14.5064 16.1144 15.518 14.8034 15.518C13.4924 15.518 12.4296 14.5064 12.4296 13.2586C12.4296 12.0107 13.4924 10.9991 14.8034 10.9991C16.1144 10.9991 17.1772 12.0107 17.1772 13.2586Z" fill="currentColor"/>
              <path d="M2.53263 0C3.70092 0 4.64801 0.932665 4.64801 2.08317C4.64801 2.93559 4.12809 3.66844 3.38351 3.99095L3.38348 8.70508H1.69117L1.69115 3.995C0.941541 3.6746 0.417241 2.93918 0.417241 2.08317C0.417241 0.932665 1.36433 0 2.53263 0Z" fill="currentColor"/>
            </svg>
            <span>typedb.com</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
          <a href="https://typedb.com/discord" target="_blank">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" id="discord">
              <path d="M12.4357 14.6C11.1897 14.8255 9.91039 14.8209 8.66614 14.5864C8.44823 14.5456 8.13975 14.4735 7.74213 14.3715L6.4389 16C3.22257 15.9007 2 13.8286 2 13.8286C2 9.22871 4.09564 5.49953 4.09564 5.49953C6.19128 3.95806 8.18503 4.00024 8.18503 4.00024L8.75529 4.71451C8.80784 4.70742 8.86074 4.70288 8.91377 4.7009C10.0008 4.56236 11.1024 4.56694 12.1881 4.71451L12.8136 4.00024C12.8136 4.00024 14.8087 3.95806 16.9029 5.50089C16.9029 5.50089 19 9.22871 19 13.8286C19 13.8286 17.7619 15.8993 14.5455 16L13.1206 14.4572C12.8937 14.5117 12.6653 14.5589 12.4357 14.6Z" stroke="currentColor"/>
              <path d="M8.00039 9C7.44162 9 7 9.45 7 10C7 10.55 7.45092 11 8.00039 11C8.55823 11 8.99986 10.55 8.99986 10C9.00916 9.45 8.55916 9 8.00039 9Z" fill="currentColor"/>
              <path d="M12.9995 9C12.4417 9 12 9.45 12 10C12 10.55 12.451 11 12.9995 11C13.5583 11 14 10.55 14 10C14 9.45 13.5583 9 12.9995 9Z" fill="currentColor"/>
            </svg>
            <span>Chat Server</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
          <a href="https://github.com/typedb/typedb" target="_blank">
            <svg viewBox="0 0 24 24" height="20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill="#f3f3f3" fill-rule="evenodd" clip-rule="evenodd" d="M12.0099 0C5.36875 0 0 5.49998 0 12.3042C0 17.7432 3.43994 22.3472 8.21205 23.9767C8.80869 24.0991 9.02724 23.7119 9.02724 23.3862C9.02724 23.1009 9.00757 22.1232 9.00757 21.1044C5.6667 21.8379 4.97099 19.6377 4.97099 19.6377C4.43409 18.2117 3.63858 17.8452 3.63858 17.8452C2.54511 17.0914 3.71823 17.0914 3.71823 17.0914C4.93117 17.1729 5.56763 18.3544 5.56763 18.3544C6.64118 20.2284 8.37111 19.6989 9.06706 19.3729C9.16638 18.5784 9.48473 18.0284 9.82275 17.7229C7.15817 17.4377 4.35469 16.3784 4.35469 11.6522C4.35469 10.3077 4.8316 9.20771 5.58729 8.35222C5.46807 8.04672 5.0504 6.78347 5.70677 5.09273C5.70677 5.09273 6.72083 4.76673 9.00732 6.35572C9.98625 6.08639 10.9958 5.94938 12.0099 5.94823C13.024 5.94823 14.0577 6.09097 15.0123 6.35572C17.299 4.76673 18.3131 5.09273 18.3131 5.09273C18.9695 6.78347 18.5515 8.04672 18.4323 8.35222C19.2079 9.20771 19.6652 10.3077 19.6652 11.6522C19.6652 16.3784 16.8617 17.4172 14.1772 17.7229C14.6148 18.1099 14.9924 18.8432 14.9924 20.0044C14.9924 21.6544 14.9727 22.9787 14.9727 23.3859C14.9727 23.7119 15.1915 24.0991 15.7879 23.9769C20.56 22.3469 23.9999 17.7432 23.9999 12.3042C24.0196 5.49998 18.6312 0 12.0099 0Z" />
            </svg>
            <span>GitHub</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
          <a href="https://typedb.com/docs" target="_blank">
            <i class="fa-light fa-files"></i>
            <span>Docs</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
          <a href="https://typedb.com/docs/core-concepts/" target="_blank">
            <i class="fa-light fa-files"></i>
            <span>Core Concepts</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
          <a href="https://typedb.com/docs/reference/typeql/" target="_blank">
            <i class="fa-light fa-files"></i>
            <span>TypeQL Guide</span>
            <i class="fa-light fa-arrow-up-right"></i>
          </a>
        </div>
      </div>
    </div>
  </article>
</tp-page-scaffold>
